import React from 'react';

interface CartIconProps {
    width?: string | number;
    height?: string | number;
    fill?: string;
}

export const CartIcon: React.FC<CartIconProps> = ({
    width = 23,
    height = 22,
    fill = 'white',
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 23 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.25405 21.333C9.24544 21.333 10.0491 20.5458 10.0491 19.5747C10.0491 18.6036 9.24544 17.8164 8.25405 17.8164C7.26266 17.8164 6.45898 18.6036 6.45898 19.5747C6.45898 20.5458 7.26266 21.333 8.25405 21.333Z"
                fill={fill}
            />
            <path
                d="M17.588 21.333C18.5794 21.333 19.3831 20.5458 19.3831 19.5747C19.3831 18.6036 18.5794 17.8164 17.588 17.8164C16.5966 17.8164 15.793 18.6036 15.793 19.5747C15.793 20.5458 16.5966 21.333 17.588 21.333Z"
                fill={fill}
            />
            <path
                d="M22.3275 3.32057C22.2607 3.23546 22.1748 3.16648 22.0764 3.11894C21.9781 3.07139 21.87 3.04653 21.7603 3.04627H5.17386L4.85075 2.04052C4.81526 1.93253 4.75362 1.83456 4.6711 1.75495C4.58858 1.67535 4.48763 1.61648 4.37685 1.58336L1.43294 0.697175C1.34242 0.669929 1.2473 0.660413 1.15303 0.669172C1.05875 0.67793 0.967161 0.704792 0.883483 0.748223C0.71449 0.835936 0.58799 0.985813 0.531812 1.16489C0.475634 1.34396 0.494381 1.53755 0.583927 1.70309C0.673474 1.86862 0.826485 1.99253 1.0093 2.04756L3.58702 2.82121L6.87559 12.9983L5.7052 13.9407L5.61186 14.0322C5.32242 14.3605 5.15844 14.7771 5.14796 15.2107C5.13748 15.6443 5.28116 16.0681 5.55442 16.4094C5.75012 16.6425 5.99881 16.8276 6.28059 16.9497C6.56236 17.0718 6.86941 17.1276 7.17716 17.1127H19.161C19.3515 17.1127 19.5341 17.0386 19.6688 16.9067C19.8034 16.7748 19.8791 16.5959 19.8791 16.4094C19.8791 16.2229 19.8034 16.044 19.6688 15.9121C19.5341 15.7802 19.3515 15.7061 19.161 15.7061H7.06227C6.97959 15.7033 6.89903 15.6797 6.82838 15.6375C6.75773 15.5954 6.69938 15.5361 6.65895 15.4654C6.61853 15.3947 6.59741 15.315 6.59762 15.2339C6.59784 15.1529 6.61938 15.0733 6.66018 15.0028L8.39063 13.5961H19.4698C19.6338 13.6008 19.7945 13.5503 19.9252 13.4531C20.0558 13.3558 20.1485 13.2176 20.1878 13.0616L22.4855 3.91839C22.5073 3.81354 22.5045 3.70519 22.4771 3.60159C22.4497 3.49799 22.3986 3.40188 22.3275 3.32057Z"
                fill={fill}
            />
        </svg>
    );
};
